import React, { memo, useMemo } from 'react';

/**
 * InputsCell - Displays inputs count/preview
 * Memoized to prevent re-renders when other cells change
 */
const InputsCell = memo(({ row }) => {
  const task = row.original;
  const inputs = task.inputs || [];
  const inputCount = inputs.length;
  
  // Memoize computed values
  const { truncated, titleText } = useMemo(() => {
    if (inputCount === 0) return { truncated: '', titleText: '' };
    
    const firstInput = inputs[0];
    const preview = typeof firstInput === 'string' 
      ? firstInput 
      : firstInput?.text || firstInput?.name || '';
    
    return {
      truncated: preview.length > 30 ? preview.substring(0, 30) + '...' : preview,
      titleText: inputs.map(i => typeof i === 'string' ? i : i?.text || i?.name || '').join('\n'),
    };
  }, [inputs, inputCount]);
  
  if (inputCount === 0) {
    return <span className="table-view__cell-empty">—</span>;
  }

  return (
    <div className="table-view__inputs-cell" title={titleText}>
      <span className="table-view__inputs-count">{inputCount}</span>
      {truncated && <span className="table-view__inputs-preview">{truncated}</span>}
    </div>
  );
}, (prevProps, nextProps) => {
  const prevTask = prevProps.row.original;
  const nextTask = nextProps.row.original;
  // Compare inputs by reference first, then by length as a quick check
  return prevTask.id === nextTask.id && 
         prevTask.inputs === nextTask.inputs;
});

export default InputsCell;
